/* Step 11d Add-on 2 · lane D6 (01-Nov-2026) — EN + AR texts.
   s11d6.third.*   item 3: the third statement of financial position on the IFRS screen (components/restatement/RestatedStatements.jsx)
                   — the RULE (required / not required: the largest effect on the opening balances of the comparative period
                   against overall materiality) is shown apart from the DECISION (presented / not presented: as the rule says,
                   or by the Partner's / Manager's override, with who, when and the reason). No standards paragraph number. */
export default {
  en: {
    s11d6: {
      third: {
        ruleRequired: "Required: the restatement's largest effect on the opening balances of the comparative period ({eff}) reaches overall materiality ({om}).",
        ruleNotRequired: "Not required: the restatement's largest effect on the opening balances of the comparative period ({eff}) is below overall materiality ({om}).",
        ruleWhy: "It is needed when a restatement reaches back before the comparative period, through opening equity, and its effect on those opening balances is material.",
        presentedByRule: "Decision: presented, as the rule says.",
        notPresentedByRule: "Decision: not presented, as the rule says.",
        presentedByOverride: "Decision: presented although below overall materiality — by {by} on {at}. Reason: {reason}",
        notPresentedByOverride: "Decision: not presented although at or above overall materiality — by {by} on {at}. Reason: {reason}",
        presentBelow: "Present it although below overall materiality",
        omitAbove: "Do not present it although at or above overall materiality",
        reasonHint: "Reason (for example: qualitative materiality, or firm policy)",
        reasonHintOmit: "Reason why it is not presented although at or above overall materiality",
      },
    },
  },
  ar: {
    s11d6: {
      third: {
        ruleRequired: "مطلوبة: أكبر أثر لإعادة العرض على الأرصدة الافتتاحية لفترة المقارنة ({eff}) يبلغ الأهمية النسبية الإجمالية ({om}).",
        ruleNotRequired: "غير مطلوبة: أكبر أثر لإعادة العرض على الأرصدة الافتتاحية لفترة المقارنة ({eff}) أقل من الأهمية النسبية الإجمالية ({om}).",
        ruleWhy: "تلزم عندما تمتد إعادة العرض إلى ما قبل فترة المقارنة من خلال حقوق الملكية الافتتاحية ويكون أثرها على تلك الأرصدة الافتتاحية جوهريًا.",
        presentedByRule: "القرار: تُعرض، وفق القاعدة.",
        notPresentedByRule: "القرار: لا تُعرض، وفق القاعدة.",
        presentedByOverride: "القرار: تُعرض رغم أنها أقل من الأهمية النسبية الإجمالية — بواسطة {by} في {at}. السبب: {reason}",
        notPresentedByOverride: "القرار: لا تُعرض رغم أنها تبلغ الأهمية النسبية الإجمالية أو تتجاوزها — بواسطة {by} في {at}. السبب: {reason}",
        presentBelow: "اعرضها رغم أنها أقل من الأهمية النسبية الإجمالية",
        omitAbove: "لا تعرضها رغم أنها تبلغ الأهمية النسبية الإجمالية أو تتجاوزها",
        reasonHint: "السبب (مثلًا: الأهمية النسبية النوعية، أو سياسة المكتب)",
        reasonHintOmit: "سبب عدم عرضها رغم أنها تبلغ الأهمية النسبية الإجمالية أو تتجاوزها",
      },
    },
  },
};
